export enum TabName {
  WEEKLY = 'Weekly',
  DAILY = 'Daily',
  MONTHLY = 'Monthly',
  CUSTOM = 'Custom',
}
